<template>
	<div>
		<v-menu rounded="lg" :minWidth="300" :maxWidth="300" offset-y dense :close-on-content-click="false">
			<template v-slot:activator="{ on, attrs, value }">
				<div v-bind="attrs" v-on="on">
					<AppTooltip :disabled="value" position="bottom" text="Click to see permission details">
						<SIcon name="installation-tab-info" width="12" height="18" />
					</AppTooltip>
				</div>
			</template>
			<div class="content-container flex-justify-space-between display-flex flex-column width-100 pa-4">
				<h3 class="reg">Spaces define who has edit and share access for features and connections.</h3>
				<DocsDispatcher docsSrc="https://docs.ply.io/manage-and-collaborate/understand-spaces">
					<a class="link mt-1" href="#">Learn more</a>
				</DocsDispatcher>
			</div>
		</v-menu>
	</div>
</template>

<script>
import DocsDispatcher from '@/components/common/DocsDispatcher';

export default {
	name: 'ProjectMenuSpacesInfo',
	props: {},
	components: { DocsDispatcher },
};
</script>

<style scoped lang="scss">
.content-container {
	height: 90px;
	background: var(--white);
}
.link {
	width: 80px;
	font-size: 14px;
	font-weight: 600;
	text-decoration: underline;
	color: var(--primary-font-color);
}
</style>
